import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import InputSelect from "@mui/material/Select";
import PropTypes from "prop-types";

export const Select = ({
  children,
  fullWidth,
  label,
  name,
  size,
  ...props
}) => {
  if (props.hidden) return null;

  return (
    <FormControl size={size} fullWidth={fullWidth} sx={{ minWidth: 90 }}>
      <InputLabel id={name + "-label"}>{label}</InputLabel>
      <InputSelect
        label={label}
        labelId={name + "-label"}
        name={name}
        {...props}
      >
        {children}
      </InputSelect>
    </FormControl>
  );
};

Select.propTypes = {
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  value: PropTypes.any, // Adjust based on expected value type
};
